import {
  anUpdateTemplatedMatchRule,
  aTemplatedMatchRule,
  mockUpdateTemplatedMatchRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { ruleBuilderQuery_match_updated } from '../queries/RuleBuilderQueryOperation.mocks';

export const updateTemplatedMatchRuleBuilderOperation = {
  __typename: 'Mutation' as const,
  updateTemplatedMatchRule: anUpdateTemplatedMatchRule({
    data: aTemplatedMatchRule({
      ...ruleBuilderQuery_match_updated.rule,
    }),
  }),
};

export const handlers = [
  mockUpdateTemplatedMatchRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: updateTemplatedMatchRuleBuilderOperation,
      });
    }
  ),
];
